// extracted by mini-css-extract-plugin
export default {"view_details":"ViewDetails_view_details__K5qa5","header_wrap":"ViewDetails_header_wrap__Ae0rX","header_button":"ViewDetails_header_button__8Ewk1","title":"ViewDetails_title__NLBin"};